module.exports = __webpack_public_path__ + "media/components/Marketing/Root/Images/Section5/Security-c1833df1dfad0abbaf8f57054a3db93f.svg";